import { appointmentStatusColorCode } from "./statusColorCode";

export const getStatusColor = (status?: string) => {
    return (
        appointmentStatusColorCode.find(
            (c) => c.label === status?.trim()?.toLowerCase()
        ) || {
            colorBg: "bg-[#000000]",
            colorText: "text-[#000000]"
        }
    );
};

export const dateToPosition = (startDate: moment.Moment, endDate: moment.Moment): number => endDate.diff(startDate, "days");